"use client";

import { buttonClassNames } from "@hisani/ui";
import { MessageCircle } from "lucide-react";
import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";
import React, { type ReactNode } from "react";
import { Link } from "../../../i18n/navigation";

export default function MarketplaceLayout({
  children,
}: {
  readonly children: ReactNode;
}) {
  const pathname = usePathname().replace(/\/+$/u, "");
  const t = useTranslations("Marketplace");
  const messagesAreCurrent = pathname.endsWith("/marketplace/conversations");
  const listingDraftIsCurrent = pathname.endsWith("/marketplace/create");

  return (
    <>
      {children}
      {messagesAreCurrent || listingDraftIsCurrent ? null : (
        <Link
          href="/marketplace/conversations"
          aria-label={t("messagesAction")}
          title={t("messagesAction")}
          className={buttonClassNames({
            variant: "accent",
            className:
              "fixed end-4 bottom-[calc(var(--mobile-bottom-navigation-height)+var(--mobile-bottom-navigation-bottom-spacing)+1rem)] z-[var(--z-index-sticky)] size-14 min-h-14 rounded-full p-0 shadow-[var(--elevation-floating)] md:end-6 md:bottom-6",
          })}
        >
          <MessageCircle className="size-6" aria-hidden="true" />
        </Link>
      )}
    </>
  );
}
